import React, { useRef } from 'react';

export default function AdvancedAiSearch() {
    const iframeRef = useRef<HTMLIFrameElement>(null);

    return (
        <div className="w-full h-[calc(100vh-74px)]">
            <iframe ref={iframeRef} src={`https://form.hellohere.es`} title="AI Powered Search" className="w-full h-full border-0" />
        </div>
    );
}
